<template>
  <div class="root-container">
    <van-search
      v-model="searchValue"
      placeholder="请输入搜索关键词"
      shape="round"
      @input="onInput"
    />
    <div id="container"></div>
    <span style="color: #888888; font-size: 13px; margin: 16px">附近位置</span>
    <div
      v-show="searchResult.length > 0 && showSearchResult"
      class="search-result"
    >
      <div
        v-for="item in searchResult"
        :key="item.id"
        class="item"
        @click="onAddressItemClick(item)"
      >
        <van-icon name="location-o" size="14" style="margin-top: 6px" />
        <div class="info">
          <div style="font-size: 15px" v-html="setPartTextcolor(item.name)" />
          <span class="address">{{ item.address }}</span>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search, Toast } from "vant";
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from "axios";
export default {
  components: {
    [Search.name]: Search,
  },
  data() {
    return {
      map: null,
      showSearchResult: false, //显示搜索结果
      searchResult: [], //搜索结果
      searchValue: null, //搜索
      poiLocation: null, // poi点坐标"lng,lat"
      cityName: '', //当前城市名 -- xx市 用于poi搜索时锁定城市
      location: null, //当前定位 格式为 经度,纬度
      address: null, //用户选择的地址
      province:'',//逆地理后保存省份
      district:'',//逆地理后保存区
    };
  },
  mounted() {
    this.cityName = this.$route.params.cityName;
    this.location = this.$route.params.location 
    if(!this.location){
      Toast.fail("获取当前定位失败,请返回重试")
      return;
    }
    //初始化地图
    this.initMap();
    //根据当前定位取附近地址列表--逆地理
    this.getAddressFromLocation();
  },
  methods: {
    initMap() {
      let arr = this.location.split(",");
      let lng = parseFloat(arr[0]);
      let lat = parseFloat(arr[1]);
      AMapLoader.load({
        key: "6b32ef5557dd2981c76546e4d8c0cd85", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15, //初始化地图级别
            center: [lng, lat], //初始化地图中心点位置
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //搜索列表点击
    onAddressItemClick(item) {
      this.address = item.name;
      this.poiLocation = item.location;

      this.$store.commit("setNewAddress", this.province + this.cityName + this.district + this.address);
      this.$store.commit("setNewLocation", this.poiLocation);

      let length = window.history.length
      this.$router.go(length > 2 ? 1 - length: -1 )
    },
    //搜索栏输入变化
    onInput(val) {
      this.searchValue = val;
      this.poiLocation = null;
      if (val) {
        this.getPoiData(val);
      } else {
        this.searchResult = [];
        this.showSearchResult = false;
      }
    },
    onConfirm() {},
    // 逆地理编码
    getAddressFromLocation() {
      Toast.loading({
        message:'加载中',
        duration:0
      })
      const url = `https://restapi.amap.com/v3/geocode/regeo?key=6657ce532af7e1ba869148dff59e8b35&extensions=all&location=${this.location}`;
      axios.get(url).then((res) => {
        console.log(res);
        Toast.clear()
        if (res.data && res.data.regeocode) {
          // 展示poi列表
          if (res.data.regeocode.pois) {
            this.searchResult = res.data.regeocode.pois;
            this.showSearchResult = true;
            this.address = this.searchResult[0].name;
            this.poiLocation = this.searchResult[0].location;
          }
          // 设置为当前省市区
          if (res.data.regeocode.addressComponent) {
            const addressComponent = res.data.regeocode.addressComponent;
            this.cityName = addressComponent.city;
            this.province = addressComponent.province
            this.district = addressComponent.district
          }
        }
      });
    },
    //调用高德API 关键字搜索POI
    getPoiData(val) {
      let url = "";
      if (this.cityName) {
        url = `https://restapi.amap.com/v5/place/text?key=6657ce532af7e1ba869148dff59e8b35&keywords=${val}&region=${this.cityName}&city_limit=true`;
      } else {
        url = `https://restapi.amap.com/v5/place/text?key=6657ce532af7e1ba869148dff59e8b35&keywords=${val}`;
      }
      axios
        .get(url)
        .then((res) => {
          console.log(res);
          if (res.data && res.data.pois) {
            this.searchResult = res.data.pois;
            this.showSearchResult = true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //高亮匹配文字
    setPartTextcolor(text) {
      const replaceReg = new RegExp(this.searchValue, "g"); // 定义匹配规则
      const replaceString =
        '<span style="color:#f00;">' + this.searchValue + "</span>";
      text = text.replace(replaceReg, replaceString);
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
.root-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f5f5f5;
  text-align: left;
}
#container {
  margin-top: 12px;
  width: 100%;
  height: 300px;
}
.search-result {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #f5f5f5;
  width: 100%;
  .item {
    display: flex;
    padding: 12px;
    .info {
      display: flex;
      flex-direction: column;
      margin-left: 4px;
      flex: 1;
      .address {
        font-size: 12px;
        color: #888888;
        margin-top: 2px;
      }
      .line{
        background: #e5e5e5;
        height: 1px;
        margin-top: 12px;
        margin-right: 12px;
      }
    }
  }
}
</style>